import { render, staticRenderFns } from "./debug-panel.vue?vue&type=template&id=a61f71d4&scoped=true"
import script from "./debug-panel.vue?vue&type=script&lang=js"
export * from "./debug-panel.vue?vue&type=script&lang=js"
import style0 from "./debug-panel.vue?vue&type=style&index=0&id=a61f71d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61f71d4",
  null
  
)

export default component.exports